'use client'

import { Box, FormControl, FormControlLabel, FormHelperText, Label, Radio, RadioGroup } from '@internations/ds'
import { Field, useField, useFormikContext } from '@util/Formik'
import type { JSX } from 'react'
import { BaseSyntheticEvent } from 'react'

const RegistrationGenderPicker = (): JSX.Element => {
    const [, { touched, error }] = useField<TGender>('gender')
    const { handleChange, setFieldValue } = useFormikContext()
    const onChange = (e: BaseSyntheticEvent) => {
        setFieldValue('gender', true)
        handleChange(e)
    }

    return (
        <>
            <Label htmlFor="gender">Gender</Label>
            <FormControl component="fieldset" error={Boolean(touched && error)}>
                <RadioGroup aria-label="gender" id="gender">
                    <Box display="flex" flexDirection="row">
                        <FormControlLabel
                            value="male"
                            control={<Field type="radio" as={Radio} name="gender" value="m" onChange={onChange} />}
                            data-testid="gender-male"
                            label="Male"
                        />
                        <FormControlLabel
                            value="female"
                            control={<Field type="radio" as={Radio} name="gender" value="f" onChange={onChange} />}
                            data-testid="gender-female"
                            label="Female"
                        />
                    </Box>
                    <FormHelperText>{Boolean(touched && error) && error}</FormHelperText>
                </RadioGroup>
            </FormControl>
        </>
    )
}

export default RegistrationGenderPicker
